// extracted by mini-css-extract-plugin
module.exports = {"termsContainer":"EulaDetailsModal_termsContainer__SZa0F","contentColumn":"EulaDetailsModal_contentColumn__nH3Oz","text":"EulaDetailsModal_text__c8OF1"};